import "../App.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useLocation } from "react-router-dom";

function PrintDetailPage(props) {
  const location = useLocation();
  const { productGroup } = location.state || {};
  var baseProduct = productGroup.baseProduct;
  var variations = productGroup.variations;
  const [selectedVariation, setSelectedVariation] = useState(
    baseProduct.metadata?.variation || "default"
  );
  const [selectedSize, setSelectedSize] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [isAdded, setIsAdded] = useState(false);
  const [error, setError] = useState("");
  const selectedProduct =
    variations.find(
      (product) => product.metadata.variation === selectedVariation
    ) || baseProduct;

  console.log("this 1", selectedProduct);

  const sizeToPriceMap = selectedProduct.prices.reduce((acc, price) => {
    const size = price.size;
    const amount = price.amount || 0;
    if (size) {
      acc[size] = amount;
    }
    return acc;
  }, {});

  const totalPrice = sizeToPriceMap[selectedSize] * quantity;
  function handleAddToCart() {
    props.addToCart({
      selectedProduct,
      selectedSize,
      selectedVariation,
      quantity,
    });
    setIsAdded(true); // Trigger animation
    setTimeout(() => setIsAdded(false), 1000);
  }

  const cartEntry = props.cartItems.find(
    (item) =>
      item.selectedProduct.id === selectedProduct.id &&
      item.selectedVariation === selectedVariation &&
      item.selectedSize === selectedSize
  );

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value, 10);
    // Check if the value is a number and > 0
    if (isNaN(value) || value <= 0) {
      setError("enter a valid quantity.");
      setQuantity(0);
    } else {
      setError("");
      setQuantity(value);
    }
  };
  const parseDescription = (text) =>
    text.split(/(\[\[.*?\]\])/g).map((part, i) =>
      part.startsWith("[[") && part.endsWith("]]") ? (
        <strong key={i} className="fw-bold">
          {part.slice(2, -2)}
        </strong>
      ) : (
        part
      )
    );

  const quantityInCart = cartEntry ? cartEntry.quantity : 0;
  return (
    <div className="PrintDetailPage">
      <div
        className={
          selectedProduct.metadata.orientation === "landscape"
            ? "landscape-print-detail flex-column gap-0"
            : "print-detail flex-column gap-0"
        }
      >
        <Link to={`/prints`}>
          {/* <button className="nav-link p-2">Go Back</button> */}
          <svg
            className="backIcon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
          </svg>
        </Link>
        <div
          className={
            selectedProduct.metadata.orientation === "landscape"
              ? "landscape-print-detail"
              : "print-detail"
          }
        >
          <div className="image-container">
            <img
              src={selectedProduct.images[0]}
              alt={selectedProduct.name}
              className="print-image-detail"
            />
          </div>
          <div className="details-container">
            <h2 className="contact-title">{selectedProduct.name}</h2>
            {selectedProduct.description && (
              <p className="text-muted testAlignEnd fs-6">
                {parseDescription(selectedProduct.description)}
              </p>
            )}
            <div className="options">
              {variations.length > 1 && (
                <div>
                  <label htmlFor={`variation-${baseProduct.id}`}>
                    variation:
                  </label>
                  <select
                    className="optionInput"
                    id={`variation-${baseProduct.id}`}
                    value={selectedVariation}
                    onChange={(e) => setSelectedVariation(e.target.value)}
                  >
                    {variations.map((variation) => (
                      <option
                        key={variation.id}
                        value={variation.metadata?.variation || "default"}
                      >
                        {variation.metadata?.variation.toLowerCase() ||
                          "Default"}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div>
                <label htmlFor={`size-${baseProduct.id}`}>size:</label>
                <select
                  className="optionInput"
                  id={`size-${baseProduct.id}`}
                  value={selectedSize}
                  onChange={(e) => setSelectedSize(e.target.value)}
                >
                  <option value="" disabled>
                    select size
                  </option>
                  {Object.keys(sizeToPriceMap)
                    .sort((a, b) => a.localeCompare(b))
                    .map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                </select>
              </div>

              <div>
                {/* <label htmlFor={`quantity-${baseProduct.id}`}>quantity:</label>
              <input
                className="quantityInput optionInput"
                type="number"
                id={`quantity-${baseProduct.id}`}
                value={quantity}
                min="0"
                onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
              />
            </div>
          </div>
          {selectedSize && (
            <p>total price: £{totalPrice.toFixed(2)}</p>
          )} */}

                {/* <small className="text-grey">
            {quantityInCart > 0 ? `${quantityInCart} In Cart` : "Not in Cart"}
          </small> */}
                <label htmlFor={`quantity-${baseProduct.id}`}>quantity:</label>
                <input
                  className="quantityInput optionInput"
                  type="number"
                  id={`quantity-${baseProduct.id}`}
                  value={quantity || ""} // Show empty string if 0
                  min="0"
                  onChange={handleQuantityChange}
                />
              </div>

              {/* Show error message if there is a validation error */}
              {error && (
                <p className="error" style={{ color: "red" }}>
                  {error}
                </p>
              )}

              {/* Show total price ONLY if selectedSize is true and quantity > 0 */}
              {selectedSize && quantity > 0 && (
                <p>total price: £{totalPrice.toFixed(2)}</p>
              )}
              <button
                onClick={handleAddToCart}
                className={`add-to-cart-btn ${isAdded ? "added" : ""}  ${
                  !selectedSize ? "disabledBtn" : ""
                }`}
                disabled={!selectedSize}
              >
                {isAdded ? "Added to Cart" : "Add to Cart"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrintDetailPage;
